import { render, staticRenderFns } from "./LoyaltyCardCarousel.vue?vue&type=template&id=7606dd75&scoped=true"
import script from "./LoyaltyCardCarousel.vue?vue&type=script&lang=js"
export * from "./LoyaltyCardCarousel.vue?vue&type=script&lang=js"
import style0 from "./LoyaltyCardCarousel.vue?vue&type=style&index=0&id=7606dd75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7606dd75",
  null
  
)

export default component.exports